import React, { memo, ReactNode } from 'react';
import { FormGroupCustom } from './styled';

interface Props {
  children: ReactNode;
  space?: boolean;
}

const FormGroup: React.FC<Props> = memo(({ children, space = true }, props) => (
  <FormGroupCustom {...props} space={space}>
    {children}
  </FormGroupCustom>
));

export default FormGroup;
